import { lighten } from "@mui/material";
import { riskPalette, riskTextColor } from "@common/risk/riskPalette";

export interface RiskLevelColor {
    backgroundColor: string;
    color: string;
}

// Soften the solid matrix color a touch so the chip reads lighter while keeping the dark text and vivid icon.
const backgroundLightenAmount = 0.65;

// A risk level is an integer 1..scale (the value in RiskArea.Matrix; RiskArea.Scale ∈ {3,4,5,6}, labelled by
// RiskArea.RiskLevels[level - 1]). We map the level's position along the scale onto the 5-step matrix palette so
// chip colors match the matrix heatmap for any configured scale — on scale 5 the five levels map 1:1 to the five
// colors; smaller/larger scales are distributed evenly across the same palette. The same bucket index drives the
// severity chevron icon, so the chip color and icon never disagree.
// Clamped because a level is only meaningful on the frame it was scored under, and callers legitimately hold
// levels from older frames — the history ledger renders a level 5 stamped under a 1-5 scale next to rows on the
// area's current 1-4 scale. Unclamped, that reads past the palette and the resulting undefined flows into MUI's
// lighten() -> decomposeColor(), which throws inside the table's renderRow and takes the whole page down.
export function riskLevelBucketIndex(level: number, scale: number): number {
    const fraction = scale > 1 ? (level - 1) / (scale - 1) : 0;
    const index = Math.round(fraction * (riskPalette.length - 1));

    return Math.min(Math.max(index, 0), riskPalette.length - 1);
}

export function getRiskLevelColor(level: number, scale: number): RiskLevelColor {
    return { backgroundColor: lighten(riskPalette[riskLevelBucketIndex(level, scale)], backgroundLightenAmount), color: riskTextColor };
}
